import { CORE_SERVICE_URLS } from '../../../Constants/Urls.constants';
import { REQUEST_ACTIONS } from '../../../Constants/Actions.constants';
import { createRequestAction } from '../../../Helpers/Action.helpers';
import { ICurrency } from '../../../Models/DTO/Currency.model';

export const requestCurrencyList = () =>
  createRequestAction<ICurrency>({
    name: REQUEST_ACTIONS.CURRENCIES,
    url: CORE_SERVICE_URLS.CURRENCIES,
    method: 'GET',
  });
